
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { StringsMixin } from '@/mixins';

@Component({
	components: { },
})
export default class SimpleChip extends Mixins(StringsMixin) {
    @Prop() item: any;
    @Prop() image: string;
    @Prop() text: string;
    @Prop( { default: 22 } ) imageSize: number;
    @Prop( { default: "mr-1" } ) imageClass: string;
    @Prop( { default: "text-caption" } ) textClass: string;
    @Prop( { type: Boolean } ) link;
    @Prop( { type: Boolean } ) noWrap;
    @Prop( { type: Boolean } ) small;
    @Prop( { type: Boolean } ) large;

    get TextClass(): string {
        var textClass: string = this.large? "text-h5" : this.textClass;
        if( this.IsLink ) textClass += " primary--text cursor-pointer";
        if( this.noWrap ) textClass += " text-no-wrap text-truncate";
        return textClass;
    }
    get IsLink(): boolean {
        if( !this.link ) return false;
        return this.IsNotEmpty(this.item);
    }
    get ImageSize(): number {
        if( this.large ) return 64;
        if( this.small ) return 22;
        return this.imageSize;
    }
    get Image(): string {
        if( this.IsNotEmpty(this.image) ) return this.image;
        return this.item?.pictureUrl;
    }

    onClick() {
        if( !this.IsLink ) return;
        this.$emit('click');
    }
    onClickImage() {
        this.onClick();
        if( this.IsEmpty(this.image) ) return;
        this.$emit('clickImage');
    }
    onClickText() {
        this.onClick();
        if( this.IsEmpty(this.text) ) return;
        this.$emit('clickText');
    }
}
